import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class Staging {
  /* 仓库项目单量占比图 */
  static getStagingPieData(option) {
    let url = `/oa/api/operation/workbench/order/num/ratio?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Staging;